<template>
    <div>
        <div class="row">
            <div class="col-sm-3">
                <div class="input-group product-search">
                    <input type="text" class="form-control" placeholder="Search" v-model="search">
                    <div class="input-group-btn">
                        <button class="btn btn-default">
                            <i class="fa fa-search"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <div class="product-form">
                    <div class="form-group">
                        <label> Category</label>
                        <select class="form-control" v-model="categorySelected" @change="getCategoryData()">
                            <option v-for="category in categories" :value="category.id">
                                {{category.name}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-sm-3" v-if="displaySubCategory && subcategories.length > 0">
                <div class="product-form">
                    <div class="form-group">
                        <label> SubCategory</label>
                        <select class="form-control" v-model="subCategorySelected" @change="getSubCategoryData()">
                            <option v-for="category in subcategories" :value="category.id">
                                {{category.name}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-sm-3" v-if="displayGroups && groups.length > 0">
                <div class="product-form">
                    <div class="form-group">
                        <label> Groups</label>
                        <select class="form-control" v-model="groupSelected" @change="getGroupData()">
                            <option v-for="category in groups" :value="category.id">
                                {{category.name}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-sm-3" v-if="displayChild && child.length > 0">
                <div class="product-form">
                    <div class="form-group">
                        <label> Child</label>
                        <select class="form-control" v-model="childSelected" @change="getChildData()">
                            <option v-for="category in child" :value="category.id">
                                {{category.name}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-sm-3" v-if="displaySubChild && subchild.length > 0">
                <div class="product-form">
                    <div class="form-group">
                        <label>Sub Child</label>
                        <select class="form-control" v-model="subchildSelected" @change="getSubChildData()">
                            <option v-for="category in subchild" :value="category.id">
                                {{category.name}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-sm-3" v-if="displayClearFilterButton">
                <div class="product-form">
                    <div class="form-group">
                        <label style="display: inline-block;height: 40px;"></label>
                        <button class="button button--small button--validate" @click="getAllProducts()">Show All</button>
                        <button class="button button--small button--validate" @click="clearFilter()">Clear Filter</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="select-product">
            <div class="row" v-if="checkedItems.length > 0">
                <div class="col-sm-3">

                    <div class="product-form">
                        <div class="form-group">
                            <label> {{this.checkedItems.length}} Items Selected (Bulk Actions)</label>
                            <select class="form-control" v-model="actionSelected" @change="updateActions()">
                                <option v-for="action in actions" :value="action">
                                    {{action}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="col-sm-3">
                    <div class="product-form">
                        <div class="form-group">
                            <label style="height: 40px;display: inline-block;"></label>
                            <button class="btn btn-danger" @click="clearActions()">Clear</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div v-if="productList.length==0">
                No result found
            </div>

            <div class="position-relative table-responsive" v-else>
                <div class="content-loader" v-if="loader">
                    <i class="fas fa-spinner fa-pulse fa-3x" aria-hidden="true"></i>
                </div>
                <table class="table table-bordered table-hover table-image table-align-center" style="background-color: #fff;">
                    <thead>
                    <tr>
                        <th scope="col"><input type="checkbox" v-model="checkedAll" @click="checkAll"></th>
                        <th scope="col">#</th>
                        <th scope="col">Name</th>
                        <th scope="col">Category Path</th>
                        <th scope="col">Image</th>
                        <th scope="col">Published</th>
                        <th scope="col">Actions</th>
                    </tr>
                    </thead>
                    <draggable v-model="productList" tag="tbody" @end="onEnd">
                        <tr v-for="item in productList">
                            <td scope="row"><input type="checkbox" v-model="checkedItems" :value="item.id"></td>
                            <td scope="row">{{ item.id }}</td>

                            <td><a :href="adminUrl+'/catalog/products/'+item.id+'/edit'" target="_blank">
                                {{ item.name }}
                            </a>
                            </td>
                            <td>{{item.category_path}}</td>
                            <td><img v-if="item.image" :src="item.image" style="width:50px;"></td>
                            <td><span v-if="item.published==1">Yes</span><span v-else>No</span></td>
                            <td>
                                <div class="btn-group">
                                    <a class="btn btn-xs btn-default dropdown-toggle fa fa-caret-down"
                                       data-toggle="dropdown" href="javascript:void(0)"><span
                                            symbol="more-dots"
                                            class="icon icon--more-dots"><svg><title>more-dots</title><use
                                            xlink:href="#more-dots"></use></svg></span></a>
                                    <ul class="dropdown-menu dropdown-menu-right">

                                        <li>
                                            <a target="__blank"
                                               :href="adminUrl+'/catalog/products/'+item.id+'/edit'"><i
                                                    class="fa fa-edit" aria-hidden="true"></i> Edit
                                            </a>
                                        </li>

                                        <li>
                                            <a href="javascript:void(0)" v-on:click="unPublished(item.id)"><i
                                                    class="fa fa-ban" aria-hidden="true"></i>
                                                <span
                                                        v-if="item.published==1">
                                                    Unpublished
                                                </span>
                                                <span v-else>
                                                    Published
                                                </span>
                                            </a>
                                        </li>


                                        <li>
                                            <a href="javascript:void(0)" v-on:click="deleteItem(item.id)"><i
                                                    class="fa fa-trash"></i>
                                                Delete
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </draggable>
                    <tfoot>
                        <tr>
                            <td colspan="7">
                                <div v-if="categorySelected == null && this.search==null ">
                                    <pagination :data="products" @pagination-change-page="getResults" :limit=2></pagination>
                                </div>

                                <div v-if="displaySubChild == true && subchildSelected != null">
                                    <pagination :data="products" @pagination-change-page="getsubChildResults" :limit=2></pagination>
                                </div>

                                <div v-if="displayChild == true && childSelected!= null && subchildSelected == null ">
                                    <pagination :data="products" @pagination-change-page="getChildResults" :limit=2></pagination>
                                </div>

                                <div v-if="displayGroups ==true && groupSelected != null && childSelected == null ">
                                    <pagination :data="products" @pagination-change-page="getGroupsResults" :limit=2></pagination>
                                </div>

                                <div v-if="displaySubCategory == true  && subCategorySelected != null && groupSelected == null ">
                                    <pagination :data="products" @pagination-change-page="getSubCategoryResults" :limit=2></pagination>
                                </div>

                                <div v-if="categorySelected != null  && subCategorySelected == null ">
                                    <pagination :data="products" @pagination-change-page="getCategoryResults" :limit=2></pagination>
                                </div>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>


</template>

<script>
    import axios from 'axios'
    import Vue from 'vue';
    import VueToast from 'vue-toast-notification';
    import 'vue-toast-notification/dist/index.css';

    Vue.component('pagination', require('laravel-vue-pagination'));
    import draggable from 'vuedraggable'

    export default {

        props: ['mainCategories'],
        components: {draggable},

        data: function () {
            return {
                categorySelected: null,
                subCategorySelected: null,
                groupSelected: null,
                childSelected: null,
                subchildSelected: null,

                displaySubCategory: false,
                displayGroups: false,
                displayChild: false,
                displaySubChild: false,
                displayClearFilterButton: false,

                products: null,
                productList: [],
                subcategories: null,
                groups: null,
                child: null,
                subchild: null,
                search: null,
                loader: null,

                checkedAll: null,
                checkedItems: [],
                actions: ['', 'Publish', 'Unpublish', 'Delete'],
                actionSelected: '',

            }
        },

        methods: {
            getData(event) {

                let that = this;
                that.loader = true;
                axios.get(this.adminApiUrl+'/products')
                    .then(function (response) {
                        that.products = response.data;
                        that.productList = response.data.data;
                        that.loader = null;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });
            },

            getCategoryData(showAll = false) {
                let qparam = showAll ? '?showAll=1' : '';
                let that = this;
                that.loader = true;
                let id = this.categorySelected;
                this.$emit('clicked-show-category', id);
                this.$emit('clicked-show-category-level', 'category');
                that.displayGroups = false;
                that.displaySubCategory = false;
                that.displayClearFilterButton = true;

                axios.get(this.adminApiUrl+'/product-category/'+id+qparam )
                    .then(function (response) {
                        that.products = response.data.products;
                        that.productList = response.data.products.data;
                        that.subcategories = response.data.children;
                        that.displaySubCategory = true;
                        that.loader = null;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });
            },

            getSubCategoryData(showAll = false) {
                let qparam = showAll ? '?showAll=1' : '';
                let that = this;
                that.loader = true;
                let id = this.subCategorySelected;
                this.$emit('clicked-show-category', id);
                this.$emit('clicked-show-category-level', 'sub-category');
                axios.get(this.adminApiUrl+'/product-subCategory/'+id+qparam )
                    .then(function (response) {
                        console.log(response.data.children.length);
                        if (response.data.children.length > 0) {
                            that.products = response.data.products;
                            that.productList = response.data.products.data;
                            that.groups = response.data.children;
                            that.displayGroups = true;

                        } else if (response.data.children.length == 0) {
                            that.products = response.data.products;
                            that.productList = response.data.products.data;
                            that.displayGroups = false;
                        }
                        that.loader = null;

                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });
            },
            getGroupData(showAll = false) {
                let qparam = showAll ? '?showAll=1' : '';
                let that = this;
                that.loader = true;
                let id = this.groupSelected;
                this.$emit('clicked-show-category', id);
                this.$emit('clicked-show-category-level', 'group');
                axios.get(this.adminApiUrl+'/product-group/'+id+qparam )
                    .then(function (response) {
                        that.products = response.data.products;
                        that.productList = response.data.products.data;
                        that.child = response.data.children;
                        that.displayChild = true;
                        that.loader = null;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });
            },

            getChildData(showAll = false) {
                let qparam = showAll ? '?showAll=1' : '';
                let that = this;
                that.loader = true;
                let id = this.childSelected;
                this.$emit('clicked-show-category', id);
                this.$emit('clicked-show-category-level', 'child');
                axios.get(this.adminApiUrl+'/product-child/'+id+qparam )
                    .then(function (response) {
                        that.products = response.data.products;
                        that.productList = response.data.products.data;
                        that.subchild = response.data.children;
                        that.displaySubChild = true;
                        that.loader = null;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });
            },

            getSubChildData(showAll = false) {
                let qparam = showAll ? '?showAll=1' : '';
                let that = this;
                that.loader = true;
                let id = this.subchildSelected;
                this.$emit('clicked-show-category', id);
                this.$emit('clicked-show-category-level', 'subchild');
                axios.get(this.adminApiUrl+'/product-subchild/'+id+qparam)
                    .then(function (response) {
                        that.products = response.data.products;
                        that.productList = response.data.products.data;
                        //that.child = response.data.children;
                        that.displaySubChild = true;
                        that.loader = null;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });
            },

            clearFilter() {
                this.$emit('clicked-show-category', null);
                this.$emit('clicked-show-category-level', null);
                this.categorySelected = null;
                this.subCategorySelected = null;
                this.groupSelected = null;
                this.childSelected = null;
                this.subchildSelected = null
                this.displaySubCategory = false;
                this.displayGroups = false;
                this.displayClearFilterButton = false;
                this.displayChild = false;
                this.displaySubChild = false;
                this.getData();
            },

            getResults(page) {
                if (typeof page === 'undefined') {
                    page = 1;
                }
                let that = this;

                axios.get(this.adminApiUrl+'/products?page='+page)
                    .then(function (response) {
                        that.products = response.data;
                        that.productList = response.data.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });
            },

            getCategoryResults(page) {
                if (typeof page === 'undefined') {
                    page = 1;
                }
                let that = this;
                let id = this.categorySelected;
                axios.get(this.adminApiUrl+'/product-category/'+id+'?page='+page)
                    .then(function (response) {
                        that.products = response.data.products;
                        that.productList = response.data.products.data;

                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });
            },
            getSubCategoryResults(page) {
                if (typeof page === 'undefined') {
                    page = 1;
                }
                let that = this;
                let id = this.subCategorySelected;
                axios.get(this.adminApiUrl+'/product-subCategory/'+id+'?page='+page)
                    .then(function (response) {
                        that.products = response.data.products;
                        that.productList = response.data.products.data;

                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });
            },
            getGroupsResults(page) {
                if (typeof page === 'undefined') {
                    page = 1;
                }
                let that = this;
                let id = this.groupSelected;
                axios.get(this.adminApiUrl+'/product-group/'+id+'?page='+page)
                    .then(function (response) {
                        that.products = response.data.products;
                        that.productList = response.data.products.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });
            },
            getChildResults(page) {
                if (typeof page === 'undefined') {
                    page = 1;
                }
                let that = this;
                let id = this.childSelected;
                axios.get(this.adminApiUrl+'/product-child/'+id+'?page='+page)
                    .then(function (response) {
                        that.products = response.data.products;
                        that.productList = response.data.products.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });
            },
            getsubChildResults(page) {
                if (typeof page === 'undefined') {
                    page = 1;
                }
                let that = this;
                let id = this.subchildSelected;
                axios.get(this.adminApiUrl+'/product-subchild/'+id+'?page='+page)
                    .then(function (response) {
                        that.products = response.data.products;
                        that.productList = response.data.products.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });
            },
            onEnd(e) {

                this.positionReset(e.newIndex, e.oldIndex, this.productList)

            },


            unPublished(id) {

                let that = this;

                axios.post(this.adminApiUrl+'/product-unpublished', {
                    id: id,
                })
                    .then(function (response) {
                        console.log(that.products.current_page);
                        that.getResults(that.products.current_page);

                        Vue.$toast.open({
                            message: response.data.message,
                            type: "success",
                            duration: 5000,
                            dismissible: true
                        })


                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });

            },

            positionReset(newIndex, oldIndex, data) {

                let that = this;
                axios.post(this.adminApiUrl+'/products-position-reset', {
                    newIndex: newIndex,
                    oldIndex: oldIndex,
                    data: data,
                })
                    .then(function (response) {
                        Vue.$toast.open({
                            message: response.data,
                            type: "success",
                            duration: 5000,
                            dismissible: true
                        })
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            productSearch() {
                let that = this;
                let keyword = this.search;

                if (this.search == null || this.search == "") {
                    this.getData();
                } else {
                    axios.get(this.adminApiUrl+'/product-search/'+keyword)
                        .then(function (response) {
                            // that.products = response.data;
                            that.productList = response.data;
                        })
                        .catch(function (error) {
                            console.log(error);
                        })
                        .then(function () {
                        });
                }

            },
            deleteItem(id) {

                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        let that = this;
                        axios.delete(this.adminApiUrl+'/product/'+id)
                            .then(function (response) {
                                that.getResults(that.products.current_page);
                                Vue.$toast.open({
                                    message: response.data.message,
                                    type: "success",
                                    duration: 5000,
                                    dismissible: true
                                })

                            })
                            .catch(function (error) {
                                this.$swal('Cancelled', 'Some error found', 'info')
                                console.log(error);
                            })
                            .then(function () {
                            });
                    }
                })


            },
            checkAll() {

                if (this.checkedAll == true) {
                    this.checkedItems = [];
                } else {
                    var selected = [];
                    this.productList.forEach(function (product) {
                        selected.push(product.id);
                    });
                    this.checkedItems = selected;
                }

            },
            updateActions() {
                console.log(this.actionSelected);
                if (this.actionSelected == "Delete") {
                    this.$swal({
                        title: 'Are you sure?',
                        text: 'You can\'t revert your action',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Yes Delete it!',
                        cancelButtonText: 'No, Keep it!',
                        showCloseButton: true,
                        showLoaderOnConfirm: true
                    }).then((result) => {
                        if (result.value) {
                            let that = this;
                            axios.post(this.adminApiUrl+'/product/bulk/delete', {
                                checkedItems: that.checkedItems,
                            })
                                .then(function (response) {

                                    Vue.$toast.open({
                                        message: response.data,
                                        type: "success",
                                        duration: 5000,
                                        dismissible: true
                                    })


                                    that.clearActions();
                                    that.clearFilter();
                                })
                                .catch(function (error) {
                                    that.$swal('Cancelled', 'Some error found', 'info')
                                    console.log(error);
                                })
                        }
                    });


                } else if (this.actionSelected == "Publish") {
                    let that = this;
                    axios.post(this.adminApiUrl+'/product/bulk/publish', {
                        checkedItems: that.checkedItems,
                    })
                        .then(function (response) {

                            Vue.$toast.open({
                                message: response.data,
                                type: "success",
                                duration: 5000,
                                dismissible: true
                            })


                            that.clearActions();
                            that.clearFilter();

                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                } else if (this.actionSelected == "Unpublish") {
                    let that = this;
                    axios.post(this.adminApiUrl+'/product/bulk/unpublish', {
                        checkedItems: that.checkedItems,
                    })
                        .then(function (response) {

                            Vue.$toast.open({
                                message: response.data,
                                type: "success",
                                duration: 5000,
                                dismissible: true
                            })


                            that.clearActions();
                            that.clearFilter();
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            },
            clearActions() {
                this.checkedAll = false;
                this.checkedItems = [];
            },
            getAllProducts() {
                if(this.categorySelected != null && this.subCategorySelected != null && this.groupSelected != null && this.childSelected != null && this.subchildSelected != null){
                    this.getSubChildData(1);
                }else if(this.categorySelected != null && this.subCategorySelected != null && this.groupSelected != null && this.childSelected != null && this.subchildSelected == null){
                    this.getChildData(1);
                }else if(this.categorySelected != null && this.subCategorySelected != null && this.subCategorySelected != '' && this.groupSelected != null && this.groupSelected != ''){
                    this.getGroupData(1);
                } else if(this.categorySelected != null && this.subCategorySelected != null  && this.subCategorySelected != ''){
                    this.getSubCategoryData(1);
                } else {
                    this.getCategoryData(1);
                }
            },

        },
        mounted: function () {
            this.getData();
        },
        watch: {
            search(after, before) {
                this.productSearch();
            },

        },
        computed: {
            url: function () {
                return process.env.MIX_API_URL;
            },
            adminUrl: function () {
                return process.env.MIX_ADMIN_URL;
            },
            categories: function () {
                return JSON.parse(this.mainCategories);
            },
            adminApiUrl: function () {
                return process.env.MIX_ADMIN_API_URL;
            }


        }
    }

</script>
